import { Box, Tooltip } from '@mui/material';

export interface ImageTooltipProps {
    children: any;
    image: string | undefined;
    imageAltText: string | undefined;
}

const ImageTooltip = (props: ImageTooltipProps): JSX.Element => {

    return (
        <Tooltip
            title={
                <Box sx={{
        border: '2px solid #000000',
        borderRadius: 1,
        overflow: 'hidden',
        display: 'inline-block',
      }}>
                <img
                    src={props.image}
                    alt={props.imageAltText}
                    style={{ width: 450, height: 'auto' }}
                />
                </Box>
            }
            arrow
            PopperProps={{
                modifiers: [
                {
                    name: 'offset',
                    options: {
                    offset: [0, 10],
                    },
                },
                ],
            }}
            componentsProps={{
                tooltip: {
                sx: {
                    maxWidth: 'none', // This disables the default constraint
                    padding: 0,        // Optional: remove extra padding if needed
                },
                },
            }}            >
            {props.children}
            </Tooltip>
        );
};

export default ImageTooltip;